import { render, staticRenderFns } from "./WomenCard.vue?vue&type=template&id=d55f4f28&"
import script from "./WomenCard.vue?vue&type=script&lang=js&"
export * from "./WomenCard.vue?vue&type=script&lang=js&"
import style0 from "./WomenCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports